var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0009 20.0041C8.02319 20.0053 6.08962 19.4194 4.44487 18.3207C2.80013 17.222 1.51814 15.6598 0.761157 13.8318C0.0041759 12.0038 -0.193768 9.99221 0.192377 8.05163C0.578521 6.11105 1.5314 4.32869 2.9304 2.93015C4.80561 1.05401 7.34893 0 10.0009 0C12.6528 0 15.1961 1.05401 17.0713 2.93015C18.9465 4.80629 20 7.35088 20 10.0041C20 12.6574 18.9465 15.202 17.0713 17.0781C16.1447 18.0094 15.0427 18.7475 13.8291 19.2498C12.6154 19.752 11.3142 20.0084 10.0009 20.0041V20.0041ZM2.00487 10.1761C2.02758 12.2903 2.88587 14.3095 4.39215 15.7924C5.89842 17.2753 7.93019 18.1014 10.0434 18.09C12.1566 18.0787 14.1793 17.2308 15.6696 15.7318C17.1599 14.2327 17.9964 12.2044 17.9964 10.0901C17.9964 7.97586 17.1599 5.94755 15.6696 4.44852C14.1793 2.94948 12.1566 2.10163 10.0434 2.09026C7.93019 2.0789 5.89842 2.90495 4.39215 4.38787C2.88587 5.87079 2.02758 7.88999 2.00487 10.0041V10.1761ZM7.41116 14.0041L6.00187 12.5941L8.59157 10.0041L6.00287 7.41415L7.41216 6.00415L10.0009 8.59415L12.5896 6.00415L13.9989 7.41415L11.4102 10.0041L13.9989 12.5941L12.5916 14.0041L10.0009 11.4141L7.41216 14.0041H7.41116Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.af47058786278fc7917fdaadaea1494b.svg";
export { ForwardRef as ReactComponent };